import React from "react";
import "./GameLayout.css";
import bgPattern from "../../assets/game/game-bg-pattern.svg";

export default function GameLayout({ title, subtitle, children }) {
  return (
    <main className="static-game-layout" style={{ backgroundImage: `url(${bgPattern})` }}>
      <section className="static-game-shell">
        <header className="static-game-header">
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </header>
        {children}
      </section>
    </main>
  );
}
